var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"right"},[_c('div',{staticClass:"title-box"},[_c('span',{staticClass:"curr"},[_vm._v(_vm._s(_vm.articleDetail.articleTitle))])]),_c('div',{staticClass:"pt-8"},[_c('div',{staticClass:"editor-content-view",domProps:{"innerHTML":_vm._s(_vm.articleDetail.content)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }